import {useEffect, useRef, useState} from "react";
import {useUser} from "UserProvider";
import {browserLocalStorage, browserSessionStorage} from "core/browserStorage";
import {fetchMarketingPreference, updateEmailConsent, updateMarketingPreference} from "./marketingApi";
import {subscribePendingEmailConsentGrant} from "./pendingEmailConsentGrant";
import {replayMarketingDecisions} from "./marketingDecisionReplay";
import {emailConsentIdentityChanged} from "./emailMarketingDecision";

/** Thin adapter over the single identity-bound coordinator; no independent grant/objection effects. */
export function useMarketingDecisionReplay(): void {
	const [user] = useUser();
	const accountId = user.isLoggedIn ? user.id : null;
	const previousIdentity = useRef(accountId);
	const [attempt, setAttempt] = useState(0);

	useEffect(() => subscribePendingEmailConsentGrant(() => setAttempt(n => n + 1)), []);
	useEffect(() => {
		emailConsentIdentityChanged(previousIdentity.current, accountId);
		previousIdentity.current = accountId;
		const local = browserLocalStorage();
		const session = browserSessionStorage();
		if (local === null || session === null) return;
		void replayMarketingDecisions(accountId, local, session, {
			readPreference: () => fetchMarketingPreference(accountId ?? undefined),
			submitGrant: ({noticeVersion, locale, expectedRevision, decisionReceipt, accountId: boundAccountId}) =>
				updateEmailConsent(true, noticeVersion, locale, expectedRevision, boundAccountId, decisionReceipt),
			submitObjection: ({policyVersion, accountId: boundAccountId}) =>
				updateMarketingPreference(true, policyVersion, boundAccountId),
		});
	}, [accountId, attempt]);
}
